// 卡片内点击事件名称枚举值
export const cardEventEnum = {
  AlarmStatisticsTabActiveChange: 'AlarmStatisticsTabActiveChange',
  RankTableTabActiveChange: 'RankTableTabActiveChange',
};

// IBMS移动端菜单编码枚举
export const IBMS_MENU_CODE = {
  intelligentLight: 'app_menu_intelligentLight',
  airConditioner: 'app_menu_airConditioner',
  dataCockpit: 'app_menu_dataCockpit',
  energyStatistics: 'app_menu_energyStatistics',
  ibmsLive: 'app_menu_ibmsLive',
};

export const optionStatus = {
  OPEN_DOOR: 'openDoor',
  OPEN_GATE: 'openGate',
  CLOSE_GATE: 'closeGate',
  RECORD: 'record',
  HUMANRECORD: 'humanRecord',
  CARRECORD: 'carRecord',
};

// 车牌号归属地
export const licenseList = [
  '冀',
  '辽',
  '皖',
  '苏',
  '鄂',
  '晋',
  '吉',
  '粤',
  '宁',
  '京',
  '豫',
  '黑',
  '鲁',
  '浙',
  '桂',
  '蒙',
  '闽',
  '川',
  '渝',
  '津',
  '云',
  '湘',
  '新',
  '赣',
  '甘',
  '陕',
  '贵',
  '青',
  '藏',
  '琼',
  '沪',
  '港',
  '澳',
  '台',
];

// 车牌号码归属地数据
export const letterList = [
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'K',
  'L',
  'M',
  'N',
  'O',
  'P',
  'Q',
  'R',
  'S',
  'T',
  'U',
  'V',
  'W',
  'X',
  'Y',
  'Z',
];
// 佛山项目id
export const foShanProjectId = 245113;
// 开发环境接口域名融合之后
export const domainName = '';

// websocket 协议头
export const websocketProtocol = window.location.protocol.startsWith('http:') ? 'ws' : 'wss';

// 数据卡片字段解释
export const pagePositionTxt = '主要用在顶部导航切换判断,展示对应的卡片。';

export const loopReqTime = 30 * 1000;

export const BUILDING_BIM_ID = 'building';

/** 青岛动投 **/

// 事件状态
export const eventStatua = {
  0: '解除告警',
  1: '告警',
};

// 事件类型
export const eventType = {
  1: 'AI告警',
};

// 工单 受理方式
export const orderStatusName = {
  0: '未受理',
};

// 产品枚举(status状态、type控制类型、unit单位) 暖风、排水
export const productType = {
  // 暖风空调系统属性枚举
  WorkStatus: {
    name: '运行状态',
    status: {
      0: '停止',
      1: '运行',
    },
  },
  ManualAutomatic: {
    name: '手自动',
    status: {
      0: '自动',
      1: '手动',
    },
  },
  FaultAlarm: {
    name: '故障报警',
    status: {
      0: '正常',
      1: '报警',
    },
  },
  FilterPressureSwitch: {
    name: '过滤网压差开关',
    status: {
      0: '干净',
      1: '堵塞',
    },
  },
  FanPressure: {
    name: '风机压差',
    status: {
      0: '无风压',
      1: '正风压',
    },
  },
  InverterFault: {
    name: '变频器故障',
    status: {
      0: '正常',
      1: '报警',
    },
  },
  AirValveOpening: {
    name: '风阀开度',
    unit: '%',
  },
  FanInverterFeedback: {
    name: '	风机变频反馈',
    unit: 'Hz',
  },
  SupplyAirTemperature: {
    name: '送风温度',
    unit: '℃',
  },
  ReturnAirTemperature: {
    name: '回风温度',
    unit: '℃',
  },
  ColdSectionFeedback: {
    name: '表冷段开度反馈',
    unit: '%',
  },
  CO2: {
    name: 'CO2监测',
    unit: 'ppm',
  },
  DeviceStatusControl: {
    name: '设备启停控制',
    type: 'switch',
    activeText: '启动',
    inactiveText: '停止',
  },
  FreshAirValve: {
    name: '新风风阀控制',
    type: 'slider',
  },
  ReturnAirValve: {
    name: '回风风阀控制',
    type: 'slider',
  },
  InverterControl: {
    name: '变频控制',
    type: 'slider',
    max: 50,
  },
  ColdSectionControl: {
    name: '表冷段开度调节',
    type: 'slider',
  },
  // 排给水属性
  MinimumLiquidLevel: {
    name: '最低液位',
    status: {
      0: '正常',
      1: '报警',
    },
  },
  NormalLiquidLevel: {
    name: '正常液位',
    status: {
      0: '正常',
      1: '报警',
    },
  },
  HighLiquidLevel: {
    name: '高液位',
    status: {
      0: '正常',
      1: '报警',
    },
  },
  OverflowLiquidLevel: {
    name: '满溢液位',
    status: {
      0: '正常',
      1: '报警',
    },
  },
  WaterPressure: {
    name: '水压力',
    unit: 'pa',
  },
  FlowSwitch: {
    name: '水流开关',
    status: {
      0: '关',
      1: '开',
    },
  },
  OnOffStatus: {
    name: '电动蝶阀状态',
    status: {
      0: '关',
      1: '开',
    },
  },
  OnOffControl: {
    name: '电动蝶阀控制',
    type: 'switch',
    activeText: '开',
    inactiveText: '关',
  },
  PumpInverterFeedback: {
    name: '泵变频反馈',
    unit: 'Hz',
  },
  BypassValveFeedback: {
    name: '压差旁通阀开度',
    unit: '%',
  },
  BypassValveControl: {
    name: '压旁通阀开度控制',
    type: 'slider',
  },
  BelowNormalLevel: {
    name: '低于正常液位',
    status: {
      0: '正常',
      1: '报警',
    },
  },
  // 照明
  lightStatus: {
    name: '照明状态',
    status: {
      1: '正常',
      0: '故障',
    },
  },
  lightDeviceStatusControl: {
    name: '照明控制',
    type: 'switch',
    activeText: '启动',
    inactiveText: '停止',
  },
};
export const PROJECTCODE = '50010014';

const appName = 'jianGangShan'; // 中间页对应文件夹及路由名

const envTimes = [];

const viewList = [
  { key: 'view1', name: '视角1', idx: 1 },
  { key: 'view2', name: '视角2', idx: 2 },
  { key: 'view3', name: '视角3', idx: 3 },
  { key: 'view4', name: '视角4', idx: 4 },
];

export { appName, envTimes, viewList };

// 设备类型
export const DEVICETYPE = {
  ELEVATOR: 'elevator', // 电梯
  BASEMENT: 'basement', // 地下室
};

// 根据租户id判断租户
export const TENANTID = {
  QINGDAO: '407634', // 青岛动投
  CHONGQINB11: '575754', // 重庆B11
  SHANGHAIZHONGYUAN: '677433', // 上海中远
  FOSHANIFC: '213088', // 佛山IFC
};
export const BimEventType = {
  MODEL_LOADING_PROGRESS: 'modelLoadingProgress',
  MODEL_LOADED: 'modelLoaded',
  FLOOR_LOADING_PROGRESS: 'floorLoadingProgress',
  FLOOR_LOADED: 'floorLoaded',
  ELEMENT_SELECT: 'elementSelect',
  PATH_FOLLOWING_ANIMATE_END: 'pathFollowingAnimateEnd',
  UIANCHOR_UPDATE: 'uiAnchorUpdate',
  CAMERA_CHANGE: 'cameraChange',
  POINT_PICKED: 'pointPicked',
  WEBGL_LOST: 'webglLost',
  FPS_LOW: 'fpsLow',
};

// 智慧监控在线状态
export const monitorOnlineStatus = [
  {
    name: '离线 ',
    count: 0,
    color: '#eb4a4a',
  },
  {
    name: '在线 ',
    count: 0,
    color: '#13ba66',
  },
];

// 智慧监控tab切换列表
export const monitorTabList = [
  {
    code: 'ElectronicMap',
    label: '电子地图',
  },
  {
    code: 'RealTimeMonitoring',
    label: '实时监控',
  },
];
// UE4引擎支持的天气枚举
export const ue4weatherList = [
  { name: 'default', text: '少云', icon: 'el-icon-partly-cloudy' },
  { name: 'sunny', text: '晴天', icon: 'el-icon-sunny' },
  { name: 'overcast', text: '阴天', icon: 'el-icon-cloudy-and-sunny' },
  { name: 'storm', text: '雷雨', icon: 'el-icon-lightning' },
  { name: 'rain', text: '小雨', icon: 'el-icon-light-rain' },
  { name: 'smog', text: '雾霾', icon: 'el-icon-cloudy' },
  { name: 'snow', text: '雪天', icon: 'el-icon-ice-cream' },
];
// UE4引擎支持的时间枚举
export const ue4timerList = [
  { name: '', text: '当前', icon: 'el-icon-place' },
  { name: '7:30', text: '晨曦', icon: 'el-icon-sunrise' },
  { name: '12:30', text: '午后', icon: 'el-icon-sunny' },
  { name: '17:00', text: '夕阳', icon: 'el-icon-sunset' },
  { name: '20:00', text: '夜幕', icon: 'el-icon-moon' },
];
// 万翼UE4引擎支持的时间枚举
export const wanyiUe4timerList = [
  // { name: -10, text: '当前', icon: 'el-icon-place', idx: -10 },
  { name: 0, text: '晨曦', icon: 'el-icon-sunrise', idx: 0 },
  { name: 1, text: '午后', icon: 'el-icon-sunny', idx: 1 },
  { name: 2, text: '夕阳', icon: 'el-icon-sunset', idx: 2 },
  { name: 3, text: '夜幕', icon: 'el-icon-moon', idx: 3 },
];

// UE4已增加的点位类型
export const ue4MarkerTypeList = [
  'camera', // 摄像头
  'human', // 门禁
  'cleanerPerson', // 保洁人员'
  'lawEnforcement', // '执法仪'
  'intrusion', // 入侵设备
  'other', // 其他设备
];
// 日期默认数据
export const dataTabList = [
  {
    name: '日',
    value: 1,
  },
  {
    name: '周',
    value: 2,
  },
  {
    name: '月',
    value: 3,
  },
  {
    name: '年',
    value: 4,
  },
];

// 判断是否启用缓存数据的key
export const IS_MOCK_KEY = 'isMock';
